import React from 'react';

import {GenericHookPaginatedList} from 'app/components/general/lists/GenericHookPaginatedList';
import {useDocumentSignoffs} from 'app/signoffs/api';
import {convertLocationParamsToFetchParams} from 'app/store/sweet-api/utils';
import {DocumentSignoffsListItem} from 'app/teams/components/TeamDetailPage/TeamSignoffsSubPage/TeamSignoffsListItem';
import {useUserDetails} from 'app/user/api';
import {gt} from 'app/utils/i18n';

import type {
  SignoffTemplateFetchParamsType,
  SignoffTemplateLocationParamsType,
} from 'app/signoffs/types';
import type {WithRouterProps} from 'react-router';
import type {SignoffDocumentSerializedType} from 'sweet-types';

export const UserSignoffsList = (routerProps: WithRouterProps) => {
  const {data: user} = useUserDetails({id: routerProps.params.userid});

  return (
    <GenericHookPaginatedList<
      SignoffDocumentSerializedType,
      SignoffTemplateLocationParamsType,
      SignoffTemplateFetchParamsType
    >
      {...routerProps}
      renderItem={(item) => (
        <DocumentSignoffsListItem object={item} key={item.signoff_id} />
      )}
      useDataHook={useDocumentSignoffs}
      hookParams={{
        user_id: routerProps.params.userid,
      }}
      convertParamsFunc={convertLocationParamsToFetchParams}
      messages={{
        notFound: ({NoResultsMessage}) => (
          <NoResultsMessage
            head={
              user?.is_guest_until != null
                ? gt('Guests cannot sign off documents')
                : gt("This member doesn't have any sign offs.")
            }
            icon="fas fa-user-clock"
          />
        ),
      }}
    />
  );
};
